import React, { FC, ReactNode } from 'react'
import { PropertyDetailsContext, PropertyDetailsContextType } from '../context/property-details'
import { FormattedPropertyData } from '../models/property-details-page/property-details-model'

type PropertyDetailsProviderProps = {
    children: ReactNode
    propertyDetails: FormattedPropertyData | null
}

export const PropertyDetailsContextProvider: FC<PropertyDetailsProviderProps> = ({ children, propertyDetails }) => {
    const value: PropertyDetailsContextType = { propertyDetails }

    return <PropertyDetailsContext.Provider value={value}>{children}</PropertyDetailsContext.Provider>
}
